import { ca } from '@cian/analytics';

export const trackBannerShow = () => trackBannerEvent('show_sopr');
export const trackBannerClick = () => trackBannerEvent('click_sopr');

function trackBannerEvent(action: 'show_sopr' | 'click_sopr') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action,
    label: 'common_cpd_landing',
    page: {
      extra: {
        source: 'listing_common_cpd_banner',
      },
    },
  });
}
